import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as Socket from '@vendus/sockets-for-cordova';

import { ModalController, Platform } from '@ionic/angular';

import { AuthService } from '../auth/auth.service';
import { ComponentsService } from '../components/components.service';


@Injectable({
    providedIn: 'root'
})
export class PrintService {

    private socket: WebSocket = {} as WebSocket;
    private serverUrl = 'ws://localhost:8080';

    printers: any = [];
    peripheral: any = false;
    quanto_prints: any = false;

    constructor(
        public db: AngularFirestore,
        public auth: AuthService,
        public components: ComponentsService,
        private platform: Platform,
        public modalController: ModalController,
        private angularAuth: AuthService
    ) {
        if (!this.components.isDesktop) {
            this.setQuantoPrints();
        }
    }

    setQuantoPrints() {
        this.socket = new WebSocket(this.serverUrl);

        this.socket.addEventListener('open', () => {
            console.log('%cQuanto prints conectado correctamente.', 'color: violet; font-weight: bold;');
            this.quanto_prints = true;
        });
    }

    printLabels(labels: any[]) {
        let data_to_print: string = '';


        labels.forEach((label: any) => {

            const prodDate = this.formatPrintDate(label.production_date, true);
            const expiDate = this.formatPrintDate(label.expiration_date);

            data_to_print += `
    
            SIZE 76 mm, 76 mm
            GAP 3 mm, 0
            DIRECTION 0
            REFERENCE 0,0
            GAPDECTEC
            CLS
            TEXT 25,40,"4",0,1,1,"${label.name}"
            TEXT 25,120,"3",0,1,1,"SKU: ${label.sku}"
            TEXT 25,200,"3",0,1,1,"Elaboracion: ${prodDate}"
            TEXT 25,280,"3",0,1,1,"Vencimiento: ${expiDate}"
            TEXT 25,360,"3",0,1,1,"Lote: ${label.batch_code}"
            TEXT 25,440,"3",0,1,1,"Responsable: ${label.user.name} ${label.user.lastname}"
            TEXT 25,520,"4",0,1,1,"Cantidad:_____________"
            PRINT 1
            `;
        })

        this.print(data_to_print);
    }

    private formatPrintDate(dateInput: any, includeTime: boolean = false): string {
        const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        let formattedDate = `${day}/${month}/${year}`;

        if (includeTime) {
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            formattedDate += ` ${hours}:${minutes}`;
        }

        return formattedDate;
    }

    print(print_info: any) {
        this.printers.forEach((printer: any) => {
            this.sendPrint(printer, print_info);
        })
    }

    // Función para imprimir
    sendPrint(printer: any, dataToPrint: any) {
        this.components.showLoader('Imprimiendo...');

        if (this.platform.is('cordova')) {
            const socket = new Socket();

            socket.open(printer.ip, printer.port, () => {
                socket.write(dataToPrint, () => {
                    socket.shutdownWrite(
                        (success: any) => console.log(success),
                        (err: any) => console.log(err)
                    );
                }, (err: any) => console.log(err));

            }, (errorMessage: any) => {
                console.log(printer);
                console.log(errorMessage);
            });

        } else {
            if (this.quanto_prints) {

                const data = {
                    ip: printer.ip,
                    port: printer.port,
                    data: dataToPrint,
                    is_labels: printer.is_labels
                };

                this.socket.send(JSON.stringify(data));
            }
        }

        setTimeout(() => {
            this.components.dismissLoader();
        }, 500);
    }

    async setPrinters() {
        const account = this.auth.account_key;
        const location = this.auth.location_key;
        const area = this.auth.area_key;

        if (account.value !== null) {
            this.printers = [];

            this.db.collection(`accounts_abc/${account}/printers`).ref
                .where('location_key', '==', location)
                .where('area_key', '==', area)
                .onSnapshot((snapshots: any) => {
                    snapshots.docChanges().forEach((element: any) => {
                        if (element.type == 'added') {
                            let printer = element.doc.data();

                            printer.$key = element.doc.id;

                            this.printers.push(printer);

                        } else if (element.type == 'modified') {
                            let printer = element.doc.data();
                            printer.$key = element.doc.id;

                            this.printers[element.oldIndex] = printer;

                        } else if (element.type == 'removed') {
                            const found = this.printers.findIndex((_element: any) => _element.$key == element.doc.id);

                            this.printers.splice(found, 1);

                        }
                    });
                }, err => {
                    console.error(err);
                });
        } else {
            // console.log('no puede acceder');
        }
    }
}
